<template>
  <span>
    <svg :width="width" :height="width" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10446_211062)">
    <path d="M5.93143 15.5828H3.5429C3.22616 15.5828 2.92239 15.4569 2.69842 15.233C2.47446 15.009 2.34863 14.7052 2.34863 14.3885V9.61144C2.34863 9.2947 2.47446 8.99094 2.69842 8.76697C2.92239 8.543 3.22616 8.41718 3.5429 8.41718H5.93143L10.1114 3.04299C10.2157 2.84024 10.3892 2.68151 10.6004 2.59549C10.8116 2.50946 11.0466 2.50182 11.2629 2.57393C11.4793 2.64604 11.6627 2.79316 11.78 2.9887C11.8974 3.18423 11.9409 3.41529 11.9027 3.64012V20.3598C11.9409 20.5846 11.8974 20.8157 11.78 21.0112C11.6627 21.2068 11.4793 21.3539 11.2629 21.426C11.0466 21.4981 10.8116 21.4905 10.6004 21.4044C10.3892 21.3184 10.2157 21.1597 10.1114 20.9569L5.93143 15.5828Z" :fill="color" :stroke="color" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.4126 9L22.4126 15M22.4126 9L16.4126 15" :stroke="color" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_10446_211062">
    <rect width="24" height="24" fill="none"/>
    </clipPath>
    </defs>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return '#757575' } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>